import { render, staticRenderFns } from "./frecuencia.vue?vue&type=template&id=27739c58&scoped=true&"
import script from "./frecuencia.vue?vue&type=script&lang=ts&"
export * from "./frecuencia.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27739c58",
  null
  
)

export default component.exports